<div class="wrapper">
  <div class="trackTitleContainer">
    <tun-scrollable-text *ngIf="(currentAudio$ | async) != null" class="trackTitle" [text]="(currentAudio$ | async).title"></tun-scrollable-text>
  </div>
  <div class="trackGroupContainer">
    <tun-scrollable-text *ngIf="(currentAudio$ | async) != null" class="trackGroup" [text]="(currentAudio$ | async).group"></tun-scrollable-text>
  </div>
</div>
